import React, { useState } from "react";
import Slider from 'react-slick';
import Modal from "./temariomodal";
import "./temario.css";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import personaje_6 from 'assets/images/red-personaje-6.png';


export default function Temario() {
  const [openModal, setOpenModal] = useState(null);

  const handleOpenModal = (e, modalId) => {
    e.preventDefault();
    setOpenModal(modalId);
  };

  const handleCloseModal = () => {
    setOpenModal(null);
  };

  const slidersettings = {
    dots: false,
    arrows: false,
    autoplay: false,
    infinite: true,
    autoplaySpeed: 3000,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          dots: true,
          arrows: true,
          autoplay: true,
        }
      }
    ]
  };

  return (
    <>
      <article className="ricoendata-temario">
        <div className="wrapper">
          <h3>Temario <span></span></h3>
          <p>La educación financiera es fundamental para entender cómo gestionar el dinero, tomar decisiones informadas, y protegerse contra posibles fraudes. RICO.EN.DATA aborda y profundiza estos temas.</p>
          <div className='ricoendata-temario__listado'>
            <Slider {...slidersettings}>
              <ul>
                <li><button onClick={(e) => handleOpenModal(e, "modal1")}>Valor y dinero</button></li>
                <li><button onClick={(e) => handleOpenModal(e, "modal2")}>Ahorro y deuda</button></li>
              </ul>
              <ul>
                <li><button onClick={(e) => handleOpenModal(e, "modal3")}>Ingresos y gastos</button></li>
                <li><button onClick={(e) => handleOpenModal(e, "modal4")}>Apuestas e inversión</button></li>
              </ul>
              <ul>
                <li><button onClick={(e) => handleOpenModal(e, "modal5")}>Presupuesto</button></li>
                <li><button onClick={(e) => handleOpenModal(e, "modal6")}>¿Qué es un banco?</button></li>
              </ul>
            </Slider>
          </div>
          <div className="ricoendata-temario__bottom">
            <a href="descargas/libreta-rico-en-data.pdf" className="descarga-libreta" target='_blank'>DESCARGÁ LA LIBRETA RICO.EN.DATA<br />y empezá a usarla ahora!</a>
            <img className="elem personaje_6" src={personaje_6} alt="" />
          </div>
        </div>
      </article>

      <Modal isOpen={openModal !== null} onClose={handleCloseModal}>
        {openModal === "modal1" && (
          <div>
            <h4>Valor y dinero</h4>
            <p>A lo largo de la historia, el valor de los bienes y servicios ha sido representado por diversos elementos como el <strong>oro, la plata o el cobre</strong>. Hoy en día, usamos el dinero como una forma común de expresar ese valor. Sin embargo, existen distintas maneras de medir lo que vale un producto o servicio, y estas formas responden a diferentes teorías económicas que buscan explicar qué es lo que le da valor a las cosas.</p>
            <p>Existen tres enfoques principales: la <strong>teoría del valor de uso</strong>, que sostiene que algo vale según su utilidad; la <strong> teoría del valor de cambio</strong>, que se enfoca en lo que se puede obtener a cambio de ese bien; y la <strong>teoría del valor trabajo</strong>, que afirma que el valor depende del esfuerzo necesario para producirlo. Estas perspectivas nos invitan a preguntarnos: ¿Para qué sirve? ¿Qué puedo obtener a cambio? ¿Cuánto trabajo costó hacerlo? Así, cada teoría nos ofrece una mirada distinta sobre cómo entendemos el valor en nuestra vida cotidiana.</p>
            <a href="https://www.youtube.com/@Banco_provincia" className="btn-verde" target="_blank" rel="noreferrer">Conocé más sobre la<br />HISTORIA DEL DINERO</a>
          </div>
        )}
        {openModal === "modal2" && (
          <div>
            <h4>Ahorro y deuda</h4>
            <p>El ahorro y la deuda son dos formas en las que manejamos nuestro dinero, y entenderlas bien nos puede ayudar a tomar mejores decisiones.</p>
            <h5>Ahorro</h5>
            <p>Ahorrar significa guardar una parte de nuestro dinero en vez de gastarlo todo de inmediato. Es como reservar una parte de lo que tenemos para usarlo más adelante, ya sea para algo que queremos o para estar preparados en caso de que surja un gasto inesperado.</p>
            <h5>Deuda</h5>
            <p>Cuando gastamos más dinero del que nos ingresa generamos una deuda. Las deudas implican una obligación hacia el futuro: en algún momento hay que devolver esa plata. Por eso es tan importante no gastar más de lo que tenemos.</p>
          </div>
        )}
        {openModal === "modal3" && (
          <div>
            <h4>Ingresos y gastos</h4>
            <h5>Ingresos</h5>
            <p>Se llama INGRESOS a todo el dinero que ingresa a nuestra economía como el salario, la mensualidad, regalos…<br />
            Hay dos tipos de ingresos: <strong>fijos y variables</strong>. Los ingresos fijos son aquellos que se reciben periódicamente y cuando hablamos de ingresos variables nos referimos a una suma de dinero que recibimos de modo ocasional.</p>
            <h5>Gastos</h5>
            <p>Llamamos GASTOS a todo el dinero que sale de nuestra economía. Pueden ser <strong>fijos o variables</strong>. Los fijos son aquellos que se repiten periódicamente, como el alquiler de la casa o la compra de alimentos, y los gastos variables son los que se realizan ocasionalmente, como por ejemplo cuando tenemos que hacer arreglos en casa, comprar ropa, etc.</p>
          </div>
        )}
        {openModal === "modal4" && (
          <div>
            <h4>Apuestas e inversión</h4>
            <p>Invertir y apostar pueden parecer similares porque en ambos casos se arriesga dinero con la esperanza de obtener una ganancia, pero son muy diferentes. Invertir implica destinar dinero a algo con valor real, como acciones, educación o un negocio, basado en análisis, estrategia y decisiones informadas.</p>
            <p>Apostar, en cambio, depende del azar y no genera crecimiento real. Las probabilidades suelen estar en contra y no hay garantías. Mientras invertir requiere conocimiento y planificación, apostar es impulsivo y riesgoso.</p>
            <p>Por eso, es clave aprender a invertir con inteligencia en lugar de dejar nuestro dinero al azar.</p>
          </div>
        )}
        {openModal === "modal5" && (
          <div>
            <h4>Presupuesto</h4>
            <p>El PRESUPUESTO es una herramienta que nos permite administrar nuestro dinero de forma eficiente o correcta.<br />
            Es importante que conozcamos nuestros posibles ingresos y egresos en un período determinado distinguiendo cuáles de ellos son fijos y cuáles son variables.</p>
            <a href="/images/ricoendata-presupuesto.jpg" target="_blank">
              <img src="/images/ricoendata-presupuesto.jpg" alt="Presupuesto - Rico en Data" />
            </a>
          </div>
        )}
        {openModal === "modal6" && (
          <div>
            <h4>¿Qué es un banco?</h4>
            <p>Un Banco es una entidad financiera cuyo principal fin es controlar y administrar el dinero que recibe de empresas o individuos para luego prestar esos fondos a otras personas, empresas o instituciones.</p>
            <p>El Banco paga una compensación, llamada <strong>interés</strong>, por esa plata que recibe de las empresas o los individuos y obtiene un beneficio por los préstamos que otorga a quienes lo solicitan. Los bancos deben cumplir las regulaciones locales y también las de su país de origen, cuando se trata de un Banco extranjero. Estas regulaciones aseguran que el riesgo de estas entidades financieras sea bajo.</p>
            <p>En nuestro país, el <strong>Banco Central</strong> es el que se encarga de regular el funcionamiento del sistema financiero y proteger nuestros derechos como usuarios/as de servicios financieros.</p>
          </div>
        )}
      </Modal>
    </>
  );
}